import { useState } from 'react';
import { REACT_APP_DISCORD_BOT_ENDPOINT } from '../config/constants';

export default function CommandLineForm({ authToken }) {
  const [Command, setCommand] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [responseMsg, setResponseMsg] = useState('');


  const handleSubmit = (e) => {
    e.preventDefault();
    fetch(REACT_APP_DISCORD_BOT_ENDPOINT, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify({ 
        command: 'submit',
        data: {
          form: 'command_line_form',
          command: Command
        }
      }),
    })
      .then((res) => res.text())
      .then((msg) => {
        setSubmitted(true);
        setResponseMsg(msg);
      });
  };

  if (submitted) {
    let content;
    try {
      const parsed = JSON.parse(responseMsg);
      content = (
        <div className="json-response-list">
          {Object.entries(parsed).map(([key, value]) => (
            <div key={key} style={{ marginBottom: '0.5em' }}>
              <strong>{key}:</strong> <span>{String(value)}</span>
            </div>
          ))}
        </div>
      );
    } catch {
      content = <p>{responseMsg}</p>;
    }
    return (
      <div className="dynamic-form">
        <div className="success-message">
          {content}
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="dynamic-form">
      <div className="form-group">
        <label className="form-label">Linha de Comando</label>
        <input
          type="text"
          value={Command}
          onChange={(e) => setCommand(e.target.value)}
          className="form-input"
        />
      </div>

      <div className="form-actions">
        <button 
          type="submit" 
          disabled={!Command}
          className="submit-button"
        >
          Enviar o comando
        </button>
      </div>

      {submitted && (
        <div className="success-message">
          <span className="success-icon">✓</span>
          <p>Linha de Comando executada com sucesso!</p>
        </div>
      )}
    </form>
  );
} 